<template>
  <div class="other-meun">
    <CommonTabMenuItem to="/">首页</CommonTabMenuItem>
    
    <!-- <CommonTabMenuItem>
      <DropDown>
        <DropList slot="list">
          <DropItem :to="item.url" v-for="item of topic" :key="item.id">{{
            item.name
          }}</DropItem>
        </DropList>
      </DropDown>
    </CommonTabMenuItem> -->
    <CommonTabMenuItem to="/GoodsList">药品中心</CommonTabMenuItem>
    <CommonTabMenuItem to="/ReferencePreparation">参比制剂目录</CommonTabMenuItem>
    <CommonTabMenuItem>
      <DropDown title="资讯中心">
        <DropList slot="list">
          <DropItem :to="item.url" v-for="item of newsList" :key="item.id">{{
            item.name
          }}</DropItem>
        </DropList>
      </DropDown>
    </CommonTabMenuItem>
    <!-- <CommonTabMenuItem to="/buyDrug">药品求购</CommonTabMenuItem> -->
    <template>
      <!-- <div @click="sign" class="sign">每日签到</div> -->
      <SignIn ref="signIn"></SignIn>
    </template>
  </div>
</template>

<script>
import SignIn from "@components/pc/nav/SignIn";
import DropDown from "@components/pc/commonTool/drop/DropDown";
import DropList from "@components/pc/commonTool/drop/DropList";
import DropItem from "@components/pc/commonTool/drop/DropItem";
import CommonTabMenuItem from "@components/pc/nav/CommonTabMenuItem";
import { getChannel } from "@api/public";
export default {
  name: "CommonTabMenu",
  components: {
    SignIn,
    DropDown,
    DropList,
    DropItem,
    CommonTabMenuItem
  },
  data() {
    return {
      newsList: [
        {
          id: 0,
          name: "健康资讯",
          url: "/healthInformation"
        },
        {
          id: 1,
          name: "药师博客",
          url: "/blogHome"
        }
      ],
      topic: []
    };
  },
  mounted() {
    this.topic = JSON.parse(localStorage.getItem("topic"));
    if (this.topic === null || this.topic.length === 0) {
      getChannel().then(res => {
        this.topic = res.data.topic;
        localStorage.setItem("topic", JSON.stringify(this.topic));
      });
    }
  },
  methods: {
    sign() {
      this.$refs.signIn.sign();
    }
  }
};
</script>

<style lang="stylus" scoped>
.other-meun
  display flex
  margin-left 25px
  font-size 16px
  .sign
    cursor pointer
    letter-spacing 2px
    line-height 40px
    padding 0 25px
    &:hover
      color #1880f4
</style>
